export type OptionalCookieCategory = 'performance' | 'functional' | 'marketing'

export type CookieCategory = 'essential' | OptionalCookieCategory

export interface CookiePreferences {
  essential: true
  performance: boolean
  functional: boolean
  marketing: boolean
}

export interface CookieConsentRecord {
  hasConsented: boolean
  preferences: CookiePreferences
  consentDate: string
  version: string
}

export interface CookieCategoryConfig {
  id: CookieCategory
  title: string
  description: string
  required: boolean
}

export const COOKIE_CONSENT_VERSION = '1.0'

export const COOKIE_CATEGORIES: CookieCategoryConfig[] = [
  {
    id: 'essential',
    title: 'Cookies Essenciais',
    description:
      'Necessários para o funcionamento básico do site, como segurança, preferências de sessão e consentimento. Não podem ser desativados.',
    required: true,
  },
  {
    id: 'performance',
    title: 'Cookies de Desempenho / Analytics',
    description:
      'Coletam informações anônimas sobre como você utiliza o site, ajudando-nos a melhorar desempenho e experiência (ex.: Google Analytics, Microsoft Clarity).',
    required: false,
  },
  {
    id: 'functional',
    title: 'Cookies Funcionais',
    description:
      'Permitem recursos aprimorados e personalização, como lembrar preferências de idioma, tema ou configurações do portal.',
    required: false,
  },
  {
    id: 'marketing',
    title: 'Cookies de Marketing',
    description:
      'Utilizados para medir campanhas e exibir conteúdo relevante (ex.: Meta Pixel, Google Ads). Preparados para uso futuro.',
    required: false,
  },
]

export const DEFAULT_PREFERENCES: CookiePreferences = {
  essential: true,
  performance: false,
  functional: false,
  marketing: false,
}

export const ALL_ACCEPTED_PREFERENCES: CookiePreferences = {
  essential: true,
  performance: true,
  functional: true,
  marketing: true,
}
